import React from 'react';
import { Navigation } from '../components/Navigation';
import { StrategySection } from '../components/StrategySection';
import { AcquisitionCriteriaSection } from '../components/AcquisitionCriteriaSection';
import { OperationalPlaybookSection } from '../components/OperationalPlaybookSection';
import { Footer } from '../components/Footer';
export function StrategyPage() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-290">
      <Navigation data-id="element-291" />
      <main className="pt-20" data-id="element-292">
        <StrategySection data-id="element-293" />
        <AcquisitionCriteriaSection data-id="element-294" />
        <OperationalPlaybookSection data-id="element-295" />
      </main>
      <Footer data-id="element-296" />
    </div>;
}